var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero is-fullheight container-full"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"title"},[_vm._v("\n            "+_vm._s(_vm.newestEvent.status.title)+"\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("\n                "+_vm._s(_vm.newestEvent.text)+"\n            ")])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c4c308e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/events/Status.vue
// module id = null
// module chunks = 